import React, { useState, useEffect } from 'react';
import { bookContent } from '../data/bookContent';

export const ProgressBar = () => {
  const [progress, setProgress] = useState(0);
  const totalChapters = bookContent.chapters.length;

  useEffect(() => {
    // Calculate progress based on saved journal entries
    let completedQuestions = 0;
    let totalQuestions = 0;

    bookContent.chapters.forEach((chapter) => {
      chapter.journalQuestions.forEach((_, qIndex) => {
        totalQuestions++;
        const storageKey = `journal-ch${chapter.id}-q${qIndex}`;
        if (localStorage.getItem(storageKey)) {
          completedQuestions++;
        }
      });
    });

    const progressPercent = totalQuestions > 0 
      ? Math.round((completedQuestions / totalQuestions) * 100) 
      : 0;
    setProgress(progressPercent);
  }, []);

  return (
    <div data-testid="progress-bar" className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-charcoal-light">Your Progress</span>
        <span className="text-sm font-medium text-sage">{progress}%</span>
      </div>
      <div className="w-full h-2 bg-stone-100 rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-sage to-sky transition-all duration-500 ease-out rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
